export default __webpack_public_path__ + "static/media/raamatut.bfbd675d.mp4";